/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterR = createReactComponent("letter-r", "IconLetterR", [
  ["path", { d: "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5", key: "svg-0" }],
  ["path", { d: "M12 13l5 7", key: "svg-1" }]
]);

export { IconLetterR as default };
//# sourceMappingURL=IconLetterR.js.map
